import { render, staticRenderFns } from "./Searchpage.vue?vue&type=template&id=bfe5469c&"
import script from "./Searchpage.vue?vue&type=script&lang=js&"
export * from "./Searchpage.vue?vue&type=script&lang=js&"
import style0 from "./Searchpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports